export default __webpack_public_path__ + "static/media/PChomeLogo2.4ca292de.png";